import React from 'react';
import PropTypes from 'prop-types';
import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal';
import DetailedScheduledTransaction from './DetailedScheduledTransaction';

class DetailedScheduledTransactionModal extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      show: false,
    };

    this.handleShow = this.handleShow.bind(this);
    this.handleClose = this.handleClose.bind(this);
  }

  handleShow() {
    this.setState({ show: true, });
  }

  handleClose() {
    this.setState({ show: false, });
  }

  render() {
    const { show, } = this.state;
    const { scheduledTransaction, transactionType, } = this.props;
    return (
      <>
        <Button variant="primary" onClick={this.handleShow}>
          Details
        </Button>

        <Modal show={show} onHide={this.handleClose} size="xl">
          <Modal.Header closeButton>
            <Modal.Title>{scheduledTransaction.id}</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            {(() => {
              if (show) {
                return <DetailedScheduledTransaction scheduledTransaction={scheduledTransaction} transactionType={transactionType} />;
              }
              return undefined;
            })()}
          </Modal.Body>
          <Modal.Footer />
        </Modal>
      </>
    );
  }
}

DetailedScheduledTransactionModal.propTypes = {
  scheduledTransaction: PropTypes.instanceOf(Object).isRequired,
  transactionType: PropTypes.instanceOf(String).isRequired,
};

export default DetailedScheduledTransactionModal;
